import { Drawer, DatePicker, Button } from "antd";
import { Calendar } from "lucide-react";
import "./index.css";
import { useDispatch } from "react-redux";
import { getClientMemberListApi } from "../../../../redux/action/Client-Member";

export default function MemberFilterDrawer({
  filterOpen,
  setFilterOpen,
  filters,
  setFilters,
  setCurrentPage,
}) {
  const riskOptions = [
    { label: "No Risk", value: "NO_RISK" },
    { label: "Low", value: "LOW_RISK" },
    { label: "Moderate", value: "MODERATE_RISK" },
    { label: "High", value: "HIGH_RISK" },
  ];
  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];
  const statusOptions = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ];

  const dispatch = useDispatch();

  // Check if any filter is active
  const isAnyFilterActive =
    filters.gender ||
    filters.riskStatus ||
    filters.startDate ||
    filters.endDate ||
    filters.status ||
    filters.ageRange;

  const clearAll = () => {
    setFilters({
      gender: null,
      riskStatus: null,
      startDate: null,
      endDate: null,
      status: null,
      ageRange: null,
    });
  };

  return (
    <Drawer
      title={
        <div className="flex justify-between items-center w-full">
          <div className="flex items-center gap-2">
            <span className="text-base font-semibold text-[#171717] font-poppins">Member Filter</span>

          </div>
          <button
            className="text-[#DC2626] text-sm font-semibold font-poppins bg-transparent border-0"
            onClick={clearAll}
          >
            Clear all
          </button>
        </div>
      }
      placement="right"
      open={filterOpen}
      onClose={() => setFilterOpen(false)}
      width={450}
      className="rounded-l-3xl"
    >
      {/* Risk Level */}
      <div className="mb-4">
        <p className="text-sm font-medium text-[#334155] font-poppins mb-2">Risk Level</p>
        <div className="flex flex-wrap gap-2">
          {riskOptions.map((risk) => (
            <button
              key={risk.value}
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  riskStatus:
                    prev.riskStatus === risk.value ? null : risk.value,
                }))
              }
              className={`px-4 py-2 rounded-xl border-0 text-[13px] font-semibold font-poppins transition ${
                filters.riskStatus === risk.value
                  ? "bg-[#2563EB] text-white"
                  : "bg-[#EFF6FF] text-[#334155] hover:bg-[#DBEAFE]"
              }`}
            >
              {risk.label}
            </button>
          ))}
        </div>
      </div>

      {/* Gender */}
      <div className="mb-4">
        <p className="text-sm font-medium text-[#334155] font-poppins mb-2">Gender</p>
        <div className="flex gap-2">
          {genderOptions.map((gender) => (
            <button
              key={gender.value}
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  gender: prev.gender === gender.value ? null : gender.value,
                }))
              }
              className={`px-4 py-2 rounded-xl border-0 text-[13px] font-semibold font-poppins transition ${
                filters.gender === gender.value
                  ? "bg-[#2563EB] text-white"
                  : "bg-[#EFF6FF] text-[#334155] hover:bg-[#DBEAFE]"
              }`}
            >
              {gender.label}
            </button>
          ))}
        </div>
      </div>

      {/* Registration Date Range */}
      <div className="mb-4">
        <p className="text-sm font-medium text-[#334155] font-poppins mb-2">Registration Date Range</p>
        <div className="flex gap-2">
          {/* From Date */}
          <div className="relative w-full">
            <DatePicker
              placeholder="From"
              className={`custom-date-picker w-full h-10 rounded-xl shadow-sm font-poppins ${
                filters.startDate
                  ? "border-[1px] border-solid border-[#2563EB]"
                  : "border-[1px] border-solid border-[#E2E8F0]"
              }`}
              onChange={(date) =>
                setFilters((prev) => ({
                  ...prev,
                  startDate: date
                    ? date.toISOString().split("T")[0]
                    : null,
                  ageRange: null,
                }))
              }
            />
            <Calendar
              size={16}
              className="text-[#64748B] absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
            />
          </div>

          {/* To Date */}
          <div className="relative w-full">
            <DatePicker
              placeholder="To"
              className={`custom-date-picker w-full h-10 rounded-xl shadow-sm font-poppins ${
                filters.endDate
                  ? "border-[1px] border-solid border-[#2563EB]"
                  : "border-[1px] border-solid border-[#E2E8F0]"
              }`}
              onChange={(date) =>
                setFilters((prev) => ({
                  ...prev,
                  endDate: date
                    ? date.toISOString().split("T")[0]
                    : null,
                  ageRange: null,
                }))
              }
            />
            <Calendar
              size={16}
              className="text-[#64748B] absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
            />
          </div>
        </div>
      </div>

      {/* Status */}
      <div className="mb-4">
        <p className="text-sm font-medium text-[#334155] font-poppins mb-2">Status</p>
        <div className="flex gap-2">
          {statusOptions.map((status) => (
            <button
              key={status.value}
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  status: prev.status === status.value ? null : status.value,
                }))
              }
              className={`px-4 py-2 rounded-xl border-0 text-[13px] font-semibold font-poppins transition ${
                filters.status === status.value
                  ? "bg-[#2563EB] text-white"
                  : "bg-[#EFF6FF] text-[#334155] hover:bg-[#DBEAFE]"
              }`}
            >
              {status.label}
            </button>
          ))}
        </div>
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-start gap-4 mt-8">
        <Button
          onClick={() => {
            setFilterOpen(false);
            setCurrentPage(1);
          }}
          className="w-[45%] border-[1px] border-solid border-[#E2E8F0] rounded-xl !py-6 bg-white text-[#334155] text-base font-semibold font-poppins hover:bg-gray-50"
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="w-[45%] btn-gradient rounded-xl !py-6 border-0 text-base font-semibold font-poppins"
          onClick={() => {
            setFilterOpen(false);
            setCurrentPage(1);

            dispatch(
              getClientMemberListApi({
                page: 0,
                size: 10,
                name: "",
                gender: filters.gender || undefined,
                riskStatus: filters.riskStatus || undefined,
                status: filters.status || undefined,
                startDate: filters.startDate || undefined,
                endDate: filters.endDate || undefined,
              })
            );
          }}
        >
          Apply Filter
        </Button>
      </div>
    </Drawer>
  );
}
